import { motion, useReducedMotion } from "framer-motion";

// One shared fade-up per major block, never per item. Framer's `once` viewport
// semantics cover the scrolled-past case, so the only guard left is the
// reduced-motion opt-out: content then renders plainly, never pre-hidden.
const Reveal = ({ as = "div", children, ...rest }) => {
	const reduceMotion = useReducedMotion();

	if (reduceMotion) {
		const Tag = as;
		return <Tag {...rest}>{children}</Tag>;
	}

	const MotionTag = motion[as] || motion.div;

	return (
		<MotionTag
			initial={{ opacity: 0, y: 10 }}
			whileInView={{ opacity: 1, y: 0 }}
			viewport={{ once: true, margin: "0px 0px -6% 0px", amount: 0.02 }}
			transition={{ duration: 0.52, ease: [0.16, 1, 0.3, 1] }}
			{...rest}
		>
			{children}
		</MotionTag>
	);
};

export default Reveal;
